import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base'

export default class Setting extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            password: '',
            id: props.Id,
            data: null,
            loading: true
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/setting/get", { id: this.getCurrentFormId() })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({
                    data: data,
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    save(e) {
        e.preventDefault();
        if (this.isBlank(this.state.data.currentCompany.fname)) {
            this.showErorrMessage("لطفا نام خود را وارد نمایید");
            return;
        }
        if (this.isBlank(this.state.data.currentCompany.lname)) {
            this.showErorrMessage("لطفا نام خانوادگی خود را وارد نمایید");
            return;
        }
        this.httpPost("api/v1/setting/save", {
            fname: this.state.data.currentCompany.fname,
            lname: this.state.data.currentCompany.lname,
            password: this.state.password
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                this.setState({
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }

    renderForm() {
        return (
            <form onSubmit={e => this.save(e)}>
                <div className="row">
                    <div className="col-md-4">
                        <div className="container" id="invoiceDateBox">
                            <h5>مشخصات کاربری</h5>
                            <div className="form-group">
                                <label>شماره موبایل</label>
                                <input className="form-control" type="text" defaultValue={this.state.data.currentCompany.mobile} readOnly={true} />
                            </div>
                            <div className="form-group">
                                <label>نام</label>
                                <input className="form-control" type="text" defaultValue={this.state.data.currentCompany.fname} onChange={e => this.state.data.currentCompany.fname = e.target.value} />
                            </div>
                            <div className="form-group">
                                <label>نام خانوادگی</label>
                                <input className="form-control" type="text" defaultValue={this.state.data.currentCompany.lname} onChange={e => this.state.data.currentCompany.lname = e.target.value} />
                            </div>
                            <div className="form-group">
                                <label>کلمه عبور</label>
                                <input className="form-control" type="password" onChange={e => this.state.password = e.target.value} />
                                <p>در صورت عدم نیاز به تغییر کلمه عبور لطفا مقدار این فیلد را خالی قرار دهید</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-group">
                    <button type="submit" className="btn btn-primary">ذخیره</button>
                </div>
            </form>
        );
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() : this.renderForm();

        return (
            <div>
                {this.state.lockScreen === 1 && this.lockScreen()}
                {this.getToastContainer()}
                {contents}
            </div>
        );
    }
}